/*
 * "Cookie Settings" in the footer reopens the cookie banner's preferences.
 *
 * The link is an ordinary menu item pointing at `#cookie-settings`, so the
 * merchant places and names it in Navigation like any other. Shopify's own
 * banner (Settings → Customer privacy) exposes `privacyBanner.showPreferences()`
 * once it has loaded; until then, or without the banner, the click does
 * nothing rather than jumping to the top of the page.
 */
document.addEventListener('click', (event) => {
  const link = /** @type {Element} */ (event.target).closest('a[href$="#cookie-settings"]');
  if (!link) return;

  event.preventDefault();
  window.privacyBanner?.showPreferences?.();
});
